import React from "react";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header from "../../Components/Header2/Header2";
import "./NeedPermis.css";
import { Link } from "react-router-dom";

const NeedPermisLoggedIn: React.FC = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // Optional: Adds a smooth scrolling animation
  });
  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className="needPermission">
          <h2>
            You are logged in but you do not have access to this page yet. Please{" "}
            <Link to="../contact">contact</Link> us for any other requests.
          </h2>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NeedPermisLoggedIn;
